<template>
<div>
  <p style="line-height:28px;">
    Syarat dan Ketentuan Penarikan Dana :
  <ol>
    <li>Minimal sisa saldo setelah penarikan adalah Rp. 50.000</li>
    <li>Penarikan dana bisa dilakukan setiap hari. saat bank online 09.00 s/d 21.00</li>
    <li>Pastikan nomor dan nama pemilik rekening tujuan penarikan dana sudah benar.</li>
    <li>irsmarket tidak bertanggung jawab atas kesalahan transfer dikarenakan kesalahan penulisan data rekening bank</li>
    <li>Konfirmasi akan dikirim melalui email apabila dana sudah diproses ke rekening tujuan.</li>
    <li>Proses pencairan dana dilakukan paling cepat H+1 setelah request penarikan.</li>
  </ol>
  </p>
</div>
</template>

<script>
export default {
  name: 'SyaratCashout'
}
</script>

<style scoped>

</style>
